import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PageInterface from '../containers/PageInterface.js'
import Content from '../containers/Content.js'

class Page extends Component {
  render () {
    const {
      className,
      active
    } = this.props

    return (
      <div className={className + (active ? ' active' : '')}>
        <PageInterface />
        <Content />
      </div>
    )
  }
}

Page.defaultProps = {
  className: 'page',
  active: false
}

Page.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  state: PropTypes.object
}

export default Page
